// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/user-round.js';

import { paths } from '../generated/user-round';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('user-round', Original, paths);
